const STORAGE_KEY = "__chunk_reload_attempted__";

const CHUNK_ERROR_PATTERNS = [
  "ChunkLoadError",
  "Loading chunk",
  "Failed to fetch dynamically imported module",
  "Importing a module script failed",
];

const isChunkError = (message) =>
  CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));

const safeGetFlag = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

const safeSetFlag = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, "true");
  } catch (error) {
    // Ignore storage errors (private mode, disabled, etc.)
  }
};

export const shouldReloadForChunkError = (error) => {
  if (!error) return false;

  const message =
    (typeof error === "string" && error) ||
    error?.message ||
    error?.name ||
    "";

  if (typeof message !== "string") return false;
  if (!isChunkError(message)) return false;

  return !safeGetFlag();
};

export const reloadOnceForChunkError = (error) => {
  if (!shouldReloadForChunkError(error)) return false;
  safeSetFlag();
  if (typeof window !== "undefined" && window.location?.reload) {
    window.location.reload();
  }
  return true;
};

export default reloadOnceForChunkError;
